import React, { useState } from 'react'
import { makeStyles } from '@material-ui/core/styles';
import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';
import Grid from '@mui/material/Grid';
import { Button, MenuItem, Select } from '@material-ui/core';
import axios from 'axios';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import InputLabel from '@mui/material/InputLabel';
import { Backdrop, CircularProgress, Typography} from "@mui/material";

import '../css/login.css'

const url = "https://nrbegzvavi.execute-api.us-east-1.amazonaws.com/dev/history/create";


const useStyles = makeStyles((theme) => ({
    root: {
        '& .MuiTextField-root': {
            margin: theme.spacing(1),
            width: '25ch',
        },
        width: '100%',
    },
    backButton: {
        marginRight: theme.spacing(1),
    },
    instructions: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
    },
}));



function getSteps() {
    return ['Datos Personales', 'Antecedentes Familiares', 'Antecedentes Personales', 'Antecedentes Gineco - OBSTETRICO', 'Habitos'];
}

function getStepContent(stepIndex, classes, props, body, handleChange, handleChangeV2) {

    switch (stepIndex) {
        case 0:
            return (<div>
                <FormControl className={classes.root}>
                    <Grid className="container">
                        <Grid item xs={12} className="header">

                            <div>
                                <TextField id="identification" label="Identificacion" value={props.affiliateInfo.id} />

                                <TextField id="name" label="Nombres" value={props.affiliateInfo.firstName + " " + props.affiliateInfo.secondName}  />

                                <TextField id="lastName" label="Apellidos" value={props.affiliateInfo.lastName + " " + props.affiliateInfo.secondLastName} />
                            </div>
                        </Grid>
                        <Grid item xs={12} className="header">
                            <div>
                            <InputLabel id="typeLabel">Especializacion</InputLabel>
                                <Select
                                    labelId="typeLabel"
                                    id="type"
                                    name="type"
                                    value={body.type}
                                    onChange={handleChangeV2}
                                    label="Especializacion"
                                >
                                    <MenuItem value={"0"}>
                                        <em>Escoger especialidad</em>
                                    </MenuItem>
                                    <MenuItem value={"Medicina General"}>1. Medicina General</MenuItem>
                                    <MenuItem value={"Medicina Interna"}>2. Medicina Interna</MenuItem>
                                    <MenuItem value={"Ginecologia y obstetricia"}>3. Ginecologia y obstetricia</MenuItem>
                                    <MenuItem value={"Pediatria"}>4. Pediatria</MenuItem>
                                    <MenuItem value={"Fisiatria"}>5. Fisiatria</MenuItem>
                                    <MenuItem value={"Cardiologia"}>6. Cardiologia</MenuItem>
                                    <MenuItem value={"Fisioterapia"}>7. Fisioterapia</MenuItem>
                                    <MenuItem value={"Fonoaudiologia"}>8. Fonoaudiologia</MenuItem>
                                    <MenuItem value={"Terapia ocupacional"}>9. Terapia ocupacional</MenuItem>
                                    <MenuItem value={"Medicina especializada"}>10. Medicina especializada</MenuItem>
                                    <MenuItem value={"Psicología"}>11. Psicología</MenuItem>
                                    <MenuItem value={"Enfermeria"}>12. Enfermeria</MenuItem>
                                    <MenuItem value={"Trabajadora Social"}>13. Trabajadora Social</MenuItem>
                                    <MenuItem value={"Nutricionista"}>14. Nutricionista</MenuItem>
                                    <MenuItem value={"Medicina Laboral"}>15. Medicina Laboral</MenuItem>
                                    <MenuItem value={"SST OCUPACIONAL"}>16. SST OCUPACIONAL</MenuItem>
                                    <MenuItem value={"Neurología"}>17. Neurología</MenuItem>
                                                                                                   
                                </Select>
                            </div>
                       
                    </Grid>
                </Grid>
                </FormControl>
            </div>);
        case 1:
        return (<div>
            <FormControl className={classes.root}>
                <Grid container className="container">
                    <Grid item xs={12} sm={6} md={4} className="header">
                            <div>
                            <InputLabel id="diabetesLabel">DIABETES</InputLabel>
                                <select
                                    labelId="diabetesLabel"
                                    id='familyBackground'
                                    name="diabetes"
                                    value={body.familyBackground.diabetes}
                                    onChange={handleChange}
                                    label="DIABETES">
                                    <option value={"NO"}>NO</option>
                                    <option value={"SI"}>SI</option>                            
                                </select>
                            </div>
                    </Grid>

                    <Grid item xs={12} sm={6} md={4}>
                            <div>
                            <InputLabel id="hypertensionLabel">HIPERTENSIÓN</InputLabel>
                                <select
                                    labelId="hypertensionLabel"
                                    id='familyBackground'
                                    name="hypertension"
                                    value={body.familyBackground.hypertension}
                                    onChange={handleChange}
                                    label="HIPERTENSIÓN">
                                    <option value={"NO"}>NO</option>
                                    <option value={"SI"}>SI</option>                            
                                </select>
                            </div>
                    </Grid>

                    <Grid item xs={12} sm={6} md={4}>
                            <div>
                            <InputLabel id="convulsiveLabel">SÍNDROME CONVULSIVO</InputLabel>
                                <select
                                    labelId="convulsiveLabel"
                                    id='familyBackground'
                                    name="convulsive"
                                    value={body.familyBackground.convulsive}
                                    onChange={handleChange}
                                    label="SÍNDROME CONVULSIVO">
                                    <option value={"NO"}>NO</option>
                                    <option value={"SI"}>SI</option>                            
                                </select>
                            </div>
                    </Grid>

                    <Grid item xs={12} sm={6} md={4}>
                            <div>
                            <InputLabel id="malformationsLabel">MALFORMACIONES</InputLabel>
                                <select
                                    labelId="malformationsLabel"
                                    id='familyBackground'
                                    name="malformations"
                                    value={body.familyBackground.malformations}
                                    onChange={handleChange}
                                    label="MALFORMACIONES">
                                    <option value={"NO"}>NO</option>
                                    <option value={"SI"}>SI</option>                            
                                </select>
                            </div>
                    </Grid>

                    <Grid item xs={12} sm={6} md={4}>
                            <div>
                            <InputLabel id="cancerLabel">CANCER</InputLabel>
                                <select
                                    labelId="cancerLabel"
                                    id='familyBackground'
                                    name="cancer"
                                    value={body.familyBackground.cancer}
                                    onChange={handleChange}
                                    label="CANCER">
                                    <option value={"NO"}>NO</option>
                                    <option value={"SI"}>SI</option>                            
                                </select>
                            </div>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                    
                        <Typography variant='h6' color='GrayText' component='h2' gutterBottom>Otros</Typography>
                        <TextField
                            id='familyBackground'
                            name='others'
                            value={body.familyBackground.others}
                            onChange={handleChange}
                            variant='outlined'
                            multiline
                            minRows={5}
                            aria-label="minimum height"
                            />
                    
                    </Grid>
                </Grid>
            </FormControl>
        </div>);
        case 2:
        return (<div>
            <FormControl className={classes.root}>
                <Grid container className="container">
                    <Grid item xs={12} sm={6} md={4}>
                            <div>
                            <InputLabel id="diabetesLabel">DIABETES</InputLabel>
                                <select
                                    labelId="diabetesLabel"
                                    id='personalBackground'
                                    name="diabetes"
                                    value={body.personalBackground.diabetes}
                                    onChange={handleChange}
                                    label="DIABETES">
                                    <option value={"NO"}>NO</option>
                                    <option value={"SI"}>SI</option>                            
                                </select>
                            </div>
                    </Grid>

                    <Grid item xs={12} sm={6} md={4}>
                            <div>
                            <InputLabel id="hypertensionLabel">HIPERTENSIÓN</InputLabel>
                                <select
                                    labelId="hypertensionLabel"
                                    id='personalBackground'
                                    name="hypertension"
                                    value={body.personalBackground.hypertension}
                                    onChange={handleChange}
                                    label="HIPERTENSIÓN">
                                    <option value={"NO"}>NO</option>
                                    <option value={"SI"}>SI</option>                            
                                </select>
                            </div>
                    </Grid>

                    <Grid item xs={12} sm={6} md={4}>
                            <div>
                            <InputLabel id="convulsiveLabel">CONVULSIONES</InputLabel>
                                <select
                                    labelId="convulsiveLabel"
                                    id='personalBackground'
                                    name="convulsive"
                                    value={body.personalBackground.convulsive}
                                    onChange={handleChange}
                                    label="CONVULSIONES">
                                    <option value={"NO"}>NO</option>
                                    <option value={"SI"}>SI</option>                            
                                </select>
                            </div>
                    </Grid>

                    <Grid item xs={12} sm={6} md={4}>
                            <div>
                            <InputLabel id="thromboticsLabel">ENF. TROMBOTICA</InputLabel>
                                <select
                                    labelId="thromboticsLabel"
                                    id='personalBackground'
                                    name="thrombotics"
                                    value={body.personalBackground.thrombotics}
                                    onChange={handleChange}
                                    label=" ENF. TROMBOTICA">
                                    <option value={"NO"}>NO</option>
                                    <option value={"SI"}>SI</option>                            
                                </select>
                            </div>
                    </Grid>

                    <Grid item xs={12} sm={6} md={4}>
                            <div>
                            <InputLabel id="valveDiseaseLabel">VALVULOPATIAS</InputLabel>
                                <select
                                    labelId="valveDiseaseLabel"
                                    id='personalBackground'
                                    name="valveDisease"
                                    value={body.personalBackground.valveDisease}
                                    onChange={handleChange}
                                    label="VALVULOPATIAS">
                                    <option value={"NO"}>NO</option>
                                    <option value={"SI"}>SI</option>                            
                                </select>
                            </div>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                            <div>
                            <InputLabel id="hepaticLabel">ENF. HEPÁTICA</InputLabel>
                                <select
                                    labelId="hepaticLabel"
                                    id='personalBackground'
                                    name="hepatic"
                                    value={body.personalBackground.hepatic}
                                    onChange={handleChange}
                                    label="ENF. HEPÁTICA">
                                    <option value={"NO"}>NO</option>
                                    <option value={"SI"}>SI</option>                            
                                </select>
                            </div>
                    </Grid>

                    <Grid item xs={12} sm={6} md={4}>
                            <div>
                            <InputLabel id="cefaleaLabel">CEFALEA</InputLabel>
                                <select
                                    labelId="cefaleaLabel"
                                    id='personalBackground'
                                    name="cefalea"
                                    value={body.personalBackground.cefalea}
                                    onChange={handleChange}
                                    label=" CEFALEA">
                                    <option value={"NO"}>NO</option>
                                    <option value={"SI"}>SI</option>                            
                                </select>
                            </div>
                    </Grid>

                    <Grid item xs={12} sm={6} md={4}>
                            <div>
                            <InputLabel id="breastPathologyLabel">PATOLOGÍA MAMARIA</InputLabel>
                                <select
                                    labelId="breastPathologyLabel"
                                    id='personalBackground'
                                    name="breastPathology"
                                    value={body.personalBackground.breastPathology}
                                    onChange={handleChange}
                                    label="PATOLOGÍA MAMARIA">
                                    <option value={"NO"}>NO</option>
                                    <option value={"SI"}>SI</option>                            
                                </select>
                            </div>
                    </Grid>

                    <Grid item xs={12} sm={6} md={4}>
                    
                        <Typography variant='h6' color='GrayText' component='h2' gutterBottom>Otros</Typography>
                        <TextField
                            id='personalBackground'
                            name='others'
                            value={body.personalBackground.others}
                            onChange={handleChange}
                            variant='outlined'
                            multiline
                            minRows={5}
                            aria-label="minimum height"
                            />
                    
                    </Grid>

                  
                    
            </Grid>
            </FormControl>
        </div>);
        case 3: 
        return (<div>
            <FormControl className={classes.root}>
                <Grid container className="container">
                    
                    <Grid item xs={12} sm={6} md={4}>
                    
                    <Typography variant='h6' color='GrayText' component='h2' gutterBottom>MENARQUIA</Typography>
                    <TextField
                        id='gineco'
                        name='menarquia'
                        value={body.gineco.menarquia}
                        onChange={handleChange}
                        variant='outlined'
                        aria-label="minimum height"
                        />
                
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                    
                    <Typography variant='h6' color='GrayText' component='h2' gutterBottom>CICLOS</Typography>
                    <TextField
                        id='gineco'
                        name='ciclos'
                        value={body.gineco.ciclos}
                        onChange={handleChange}
                        variant='outlined'
                        aria-label="minimum height"
                        />
                
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                    
                    <Typography variant='h6' color='GrayText' component='h2' gutterBottom>FUM</Typography>
                    <TextField
                        id='gineco'
                        name='fum'
                        value={body.gineco.fum}
                        onChange={handleChange}
                        variant='outlined'
                        aria-label="minimum height"
                        />
                
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                    
                    <Typography variant='h6' color='GrayText' component='h2' gutterBottom>GRAVIDA</Typography>
                    <TextField
                        id='gineco'
                        name='gravida'
                        value={body.gineco.gravida}
                        onChange={handleChange}
                        variant='outlined'
                        aria-label="minimum height"
                        />
                
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                    
                    <Typography variant='h6' color='GrayText' component='h2' gutterBottom>PARTOS</Typography>
                    <TextField
                        id='gineco'
                        name='partos'
                        value={body.gineco.partos}
                        onChange={handleChange}
                        variant='outlined'
                        aria-label="minimum height"
                        />
                
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                    
                    <Typography variant='h6' color='GrayText' component='h2' gutterBottom>ABORTOS</Typography>
                    <TextField
                        id='gineco'
                        name='abortos'
                        value={body.gineco.abortos}
                        onChange={handleChange}
                        variant='outlined'
                        aria-label="minimum height"
                        />
                
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                    
                    <Typography variant='h6' color='GrayText' component='h2' gutterBottom>CESAREA</Typography>
                    <TextField
                        id='gineco'
                        name='cesarea'
                        value={body.gineco.cesarea}
                        onChange={handleChange}
                        variant='outlined'
                        aria-label="minimum height"
                        />
                
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                            <InputLabel id="dismenorreaLabel">DISMENORREA:</InputLabel>
                                <select
                                    labelId="dismenorreaLabel"
                                    id='gineco'
                                    name="dismenorrea"
                                    value={body.gineco.dismenorrea}
                                    onChange={handleChange}
                                    label="DISMENORREA">
                                    <option value={"NO"}>NO</option>
                                    <option value={"SI"}>SI</option>                            
                                </select>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>

                    <Typography variant='h6' color='GrayText' component='h2' gutterBottom>COMP. SEX ULT AÑO</Typography>
                    <TextField
                        id='gineco'
                        name='quantityMen'
                        value={body.gineco.quantityMen}
                        onChange={handleChange}
                        variant='outlined'
                        aria-label="minimum height"
                        />
                          
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                            <InputLabel id="epiLabel">ANTECEDENTES DE EPI</InputLabel>
                                <select
                                    labelId="epiLabel"
                                    id='gineco'
                                    name="epi"
                                    value={body.gineco.epi}
                                    onChange={handleChange}
                                    label="ANTECEDENTES DE EPI">
                                    <option value={"NO"}>NO</option>
                                    <option value={"SI"}>SI</option>                            
                                </select>
                    </Grid>
                    
                    <Grid item xs={12} sm={6} md={4}>    
                            <InputLabel id="lactandoLabel">LACTANDO</InputLabel>
                                <select
                                    labelId="lactandoLabel"
                                    id='gineco'
                                    name="lactando"
                                    value={body.gineco.lactando}
                                    onChange={handleChange}
                                    label="LACTANDO">
                                    <option value={"NO"}>NO</option>
                                    <option value={"SI"}>SI</option>                            
                                </select>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>   
                            <InputLabel id="moreKidsLabel">DESEA MAS HIJOS</InputLabel>
                                <select
                                    labelId="moreKidsLabel"
                                    id='gineco'
                                    name="moreKids"
                                    value={body.gineco.moreKids}
                                    onChange={handleChange}
                                    label="DESEA MAS HIJOS">
                                    <option value={"NO"}>NO</option>
                                    <option value={"SI"}>SI</option>                            
                                </select>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>   
                            <InputLabel id="sexualIlnessLabel">ENF. TRAS. SEXUAL</InputLabel>
                                <select
                                    labelId="sexualIlnessLabel"
                                    id='gineco'
                                    name="sexualIlness"
                                    value={body.gineco.sexualIlness}
                                    onChange={handleChange}
                                    label="ENF. TRAS. SEXUAL">
                                    <option value={"NO"}>NO</option>
                                    <option value={"SI"}>SI</option>                            
                                </select>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12}>
                    
                        <Typography variant='h6' color='GrayText' component='h2' gutterBottom>Otros</Typography>
                        <TextField
                            id='gineco'
                            name='others'
                            value={body.gineco.others}
                            onChange={handleChange}
                            variant='outlined'
                            multiline
                            minRows={5}
                            aria-label="minimum height"
                            />
                    
                    </Grid>
                    
            </Grid>
            </FormControl>
            </div>); 
        case 4: 
         return (<div>
        <FormControl className={classes.root}>
            <Grid container className="container">
                <Grid item xs={12} sm={6} md={4}>
                        <InputLabel id="alcoholLabel">ALCOHOL</InputLabel>
                            <select
                                labelId="alcoholLabel"
                                id='habits'
                                name="alcohol"
                                value={body.habits.alcohol}
                                onChange={handleChange}
                                label="ALCOHOL">
                                <option value={"NO"}>NO</option>
                                <option value={"SI"}>SI</option>                            
                            </select>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>    
                        <InputLabel id="smokesLabel">CIGARRILLO/ ABACO</InputLabel>
                            <select
                                labelId="smokesLabel"
                                id='habits'
                                name="smokes"
                                value={body.habits.smokes}
                                onChange={handleChange}
                                label="CIGARRILLO/ ABACO">
                                <option value={"NO"}>NO</option>
                                <option value={"SI"}>SI</option>                            
                            </select>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>   
                        <InputLabel id="drugsLabel">DROGAS</InputLabel>
                            <select
                                labelId="drugsLabel"
                                id='habits'
                                name="drugs"
                                value={body.habits.drugs}
                                onChange={handleChange}
                                label="DROGAS">
                                <option value={"NO"}>NO</option>
                                <option value={"SI"}>SI</option>                            
                            </select>
                </Grid>

                
                <Grid item xs={12} sm={12} md={12}>
                
                    <Typography variant='h6' color='GrayText' component='h2' gutterBottom>Otros</Typography>
                    <TextField
                        id='habits'
                        name='others'
                        value={body.habits.others}
                        onChange={handleChange}
                        variant='outlined'
                        multiline
                        minRows={5}
                        aria-label="minimum height"
                        />
                
                </Grid>
                
        </Grid>
        </FormControl>
        </div>);      
      default:
            return 'Unknown stepIndex';
    }
}


function CreateHistory(props) {
    const classes = useStyles();
    const [body, setBody] = useState({ type: "0", patient: {}, evolutions: [], evolutionsNutricionist: [],
        habits: {alcohol:'NO', smokes:'NO', drugs:'NO', others: ''}, 
        gineco: {menarquia: '', ciclos: '', fum: '', gravida: '', partos: '', abortos: '', cesarea: '',
        dismenorrea: 'NO', quantityMen: '', epi: 'NO', lactando: 'NO', moreKids: 'NO', sexualIlness: 'NO', others: ''  },
        personalBackground: {diabetes:'NO', hypertension:'NO', convulsive:'NO', thrombotics:'NO', valveDisease:'NO', hepatic:'NO', cefalea:'NO', breastPathology:'NO', others: ''}, 
        familyBackground: {diabetes:'NO', hypertension:'NO', convulsive:'NO', malformations:'NO', cancer:'NO', others:'' } })
    const [activeStep, setActiveStep] = React.useState(0);
    const [openLoader, setOpenLoader] = React.useState(false);
    const [evolution, setEvolution] = useState([{ 
      generalities: {externalCause: 'OTRA', reason: '', illness: '',},
      systemsReview: {generalSymptoms: '', respiratorySystem: '', cardiovascularSystem: '',
                      gastrointestinalSystem: '', genitourinarySystem: '', endocrineSystem: '',
                       neurologicalSystem: ''},
      vitalSigns: {hhpressure:'', pressureMM:'',  temperature:'', weight:'', size:'', imc: 0,
                 abdominalPerimeter:'', headCircunference:'', brachialPerimeter:'', heartRate:'',
                 breathingFrequency:''
        },
          physicalExam: {
              state: 'CONCIENTE',
              generalAspect: 'NORMAL',
              head: 'NORMAL',
              visualAcuity: 'NORMAL',
              neck: 'NORMAL',
              chest: 'NORMAL',
              abdomen: 'NORMAL',
              genitourinary: 'NORMAL',
              musculoskeletal: 'NORMAL',
              skin: 'NORMAL',
              neurological: 'NORMAL',
          },
          plan: {
            descriptions: '',
            observations: ''
          },
          barthel: {
            score: -1,
            observations: 'CARDIOVASCULAR, TRASTORNO DE LA PIEL, DEL COMPORTAMIENTO',
            comer: 0,
            translate: 0,
            cleanPersonal: 0,
            retrete: 0,
            bath: 0,
            move: 0,
            escalera: 0,
            dressed: 0,
            heces: 0,
            orina: 0
          },
          assessmentDate: new Date(),
          procedures: [],
      diagnoses: [],
      referrals: [],
      treatments: [],
      scoreKarnofsky: "No aplica",
      scoreFAC: "No aplica",
      useBarthel: false }])

      const  [evolutionTherapy, setEvolutionTherapy] = useState([{ valoration: '', objective: '', activity: '',
        therapy: '', conclusion:'', assessmentDate: new Date()
     }])

     const  [evolutionLaboral, setEvolutionLaboral] = useState([{
         generalities: {externalCause: 'OTRA', reason: '', illness: '',},
         companies:[],
         diagnoses: [],
         tipoReintegro: '',
         contintegnciasType: {accidenteTrabajo: "ACCIDENTE DE TRABAJO(AT)", enfermedadLaboral: '', origen: '',},
         desde: new Date(), 
         hasta: new Date(),
         physicalExam: {
            state: '',
            generalAspect: '',
            head: '',
            visualAcuity: '',
            neck: '',
            chest: '',
            abdomen: '',
            genitourinary: '',
            musculoskeletal: '',
            skin: '',
            neurological: '',
        },
        plan: {
          descriptions: '',
          observations: ''
        },
         conclusiones: '',
         useBarthel: false,
         barthel: {
            score: -1
         },
         treatments: [],
         referrals: [],
         assessmentDate: new Date()
    }])

     const frecuencyFood = new Map([
        ['LACTEOS', 'NUNCA'],
        ['CEREALES', 'NUNCA'],
        ['CARNES', 'NUNCA'],
        ['FRUTAS', 'NUNCA'],
        ['VERDURAS', 'NUNCA'],
        ['LEGUMINOSAS', 'NUNCA'],
        ['GRASAS', 'NUNCA'],
        ['AZUCARES', 'NUNCA'],
      ]);
     const  [evolutionNutricionist, setEvolutionNutricionist] = useState([
        { 
            assessmentDate: new Date(),
            bedRidden: false,
            edema: false,
            eyeExam: '',
            hairExam: '',
            skinExam: '',
            weight: 0,
            height: 0,
            imc: 0,
            mainDiagnosis: '',
            descriptionDiagnosis: '',
            frequencyFoodConsumption:frecuencyFood,
            reminderSummary: [
                {
                    id:'1',
                    day: 'DESAYUNO',
                    option: '', 
                  
                },
                {
                    id:'2',
                    day: 'ALMUERZO',
                    option: '', 
                 
                },
                {
                    id:'3',
                    day: 'CENA',
                    option: '', 
                   
                },
                {
                    id:'4',
                    day: 'REFRIGERIO',
                    option: '', 
                   
                }
            ],
            mealPlan: [
                {
                    id:'1',
                    day: 'Lunes',
                    desayuno: '', 
                    mediaMa: '', 
                    almuerzo: '',   
                    mediaTa: '', 
                    cena: '', 
                },
                {
                    id:'2',
                    day: 'Martes',
                    desayuno: '', 
                    mediaMa: '', 
                    almuerzo: '',   
                    mediaTa: '', 
                    cena: '', 
                },
                {
                    id:'3',
                    day: 'Miercoles',
                    desayuno: '', 
                    mediaMa: '', 
                    almuerzo: '',   
                    mediaTa: '', 
                    cena: '', 
                },
                {
                    id:'4',
                    day: 'Jueves',
                    desayuno: '', 
                    mediaMa: '', 
                    almuerzo: '',   
                    mediaTa: '', 
                    cena: '', 
                },
                {
                    id:'5',
                    day: 'Viernes',
                    desayuno: '', 
                    mediaMa: '', 
                    almuerzo: '',   
                    mediaTa: '', 
                    cena: '', 
                }
            ],
            apetito: '',
            allergic: false,
            descriptionAllergic: '',
            allergicFamily: false,
            descriptionAllergicFamily: '',
            nutricionistDiagnosis: '',
            nutricionistPlan: [],
            foodNotAllowedEat: [],
            foodCanEat: [],
            fruitCanEat: [],
            conclusion: '',
            recipeBook: [],
        }])
    const steps = getSteps();

    const isTherapy = (type) => {
       return (type == "Fisioterapia" || type == "Fonoaudiologia" 
                || type == "Terapia ocupacional" || type == "Psicología"
                || type == "SST OCUPACIONAL")
    }
    const handleChangeV2 = e => {
        setBody({
            ...body,
            [e.target.name]: e.target.value
        })
    }

    const handleChange = e => {
        const { id, name, value } = e.target;
       // console.log("id " + id + " name " + name + " values " + value);
        setBody(body => ({
          ...body,
      
          [id]: {
            ...body[id],
      
                  [name]: value
               
          }
        }));
      };

    const handleNext = () => {
        let incremento = 1;
           // console.log("activeStep" + activeStep + " Genero " + props.affiliateInfo.gender);
        if (activeStep === 2 && props.affiliateInfo.gender ===  "MASCULINO") {
            incremento = 2;
        }
        setActiveStep((prevActiveStep) => prevActiveStep + incremento);
    };

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    return (
        <div>
            <Stepper activeStep={activeStep} alternativeLabel>
                {steps.map((label) => (
                    <Step key={label}>
                        <StepLabel>{label}</StepLabel>
                    </Step>
                ))}
            </Stepper>

            <div>{getStepContent(activeStep, classes, props, body, handleChange, handleChangeV2)}</div>


            <div>

                <div>
                    <Button
                        disabled={activeStep === 0}
                        onClick={handleBack}
                        className={"buttonBack"}>
                        Back
                    </Button>
                    <Button variant="contained" className="buttonNext"
                        color="primary" onClick={() => {
                            if(body.type == "0"){
                                return false;
                            }
                        if( ((activeStep === steps.length - 1) 
                        || isTherapy(body.type)
                        || (body.type == "Enfermeria")
                        || (body.type == "Trabajadora Social")
                        || (body.type == "Nutricionista")
                        || (body.type == "Medicina Laboral") )) {
                                body.patient = props.affiliateInfo;
                                if (body.type == "Nutricionista") {
                                    body.evolutions = null;
                                    body.evolutionsNutricionist = evolutionNutricionist;
                                    body.evolutions = null;
                                    body.personalBackground = null;
                                    body.familyBackground = null;
                                    body.habits = null;
                                } else if (isTherapy(body.type) ) {
                                    body.evolutions = evolutionTherapy;
                                    body.personalBackground = null;
                                    body.familyBackground = null;
                                    body.habits = null;
                                }  else if (body.type == "Medicina Laboral" ) {
                                    body.evolutions = evolutionLaboral;
                                    body.personalBackground = null;
                                    body.familyBackground = null;
                                    body.habits = null;
                                }  else {
                                    body.evolutions = evolution; 
                                }
                              
                                body.medicalTeam = props.user;
                                setOpenLoader(true);
                               // console.log("Create history-->>: " +JSON.stringify(body))
                                axios.post(url, body).then(response => {
                                
                                //console.log("lo que enviamos -->>: " +JSON.stringify(response.data))
                                props.setIndexEvolution(0);
                                props.setAffiliate(response.data);
                                setOpenLoader(false);
                                if((response.data.type == "Nutricionista")) {
                                    props.changeMenu(17);
                                } else if((response.data.type == "Enfermeria")) {
                                    props.changeMenu(14);
                                } else if((response.data.type == "Trabajadora Social")) {
                                    props.changeMenu(15);
                                } else if(isTherapy(response.data.type)) {
                                    props.changeMenu(7);
                                } else if((response.data.type == "Medicina Laboral")) {
                                    props.changeMenu(18);
                                } else {
                                    props.changeMenu(6);
                                }
                                
                            });
                            
                        } else {
                            handleNext();
                        }
                        }}>
                        {activeStep === steps.length - 1 ? 'Finish' : 'Next'}
                    </Button>
                </div>
            </div>


            <Backdrop
            sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={openLoader}>
            <CircularProgress color="inherit" />
        </Backdrop>
        </div>
    );
};

export default CreateHistory;